import component from "./components/component"

console.log('home')
component();